import { Components, Theme } from '@mui/material';

export default {
  styleOverrides: {
    default: ({ theme }: { theme: Theme }) => ({
      backgroundColor: theme.palette.background.default,
      color: theme.palette.neutral.onSurface,
    }),
  }
} as Components<Theme>['MuiFab'];